import {Component, OnInit} from '@angular/core';



@Component({
    selector: 'app-download-current-past-rates',
    templateUrl: './download-current-past-rates.component.html',
    styleUrls: ['./download-current-past-rates.component.css'],
    standalone: false
})
  export class DownloadCurrentPastRateComponent implements OnInit {
    title: string;
    ngOnInit(): void {
      this.title = 'Download Current/Past Rates';
    }
  }
